import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as styles from './Accordion.module.scss';
import clsx from 'clsx';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  startsOpen?: boolean;
  useGreenAccordion?: boolean;
}

const Accordion = ({
  title,
  children,
  startsOpen,
  useGreenAccordion,
}: AccordionProps): React.ReactElement => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(!!startsOpen);
  return (
    <section
      className={clsx(
        styles.accordion,
        isAccordionOpen && styles.accordionOpen,
        useGreenAccordion && styles.greenAccordion,
      )}
    >
      <div
        className={clsx(styles.accordionBox, useGreenAccordion && styles.greenAccordion)}
        onClick={() => {
          setIsAccordionOpen(!isAccordionOpen);
        }}
      >
        <h3 className={clsx(styles.titleBox, useGreenAccordion && styles.greenAccordion)}>
          {title}
        </h3>
        <FontAwesomeIcon
          icon="chevron-down"
          className={clsx(styles.icon, useGreenAccordion && styles.greenAccordion)}
        />
      </div>
      <div className={styles.body}>{children}</div>
    </section>
  );
};

export default Accordion;
